import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { ImagePlus, Loader2, Check } from "lucide-react";
import { toast } from "sonner";

const selectCls = "w-full rounded-xl border border-sugar-border bg-white px-3 py-2.5 text-sm text-sugar-ink focus:border-sugar-pink focus:outline-none";

const ImageField = ({ field, value, onChange }) => {
  const [uploading, setUploading] = useState(false);
  const [name, setName] = useState("");
  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { toast.error(`"${file.name}" is too large (max 10MB).`); return; }
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/public-upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url); setName(file.name);
    } catch (err) {
      toast.error(err.response ? apiError(err.response.data?.detail) : "Couldn't reach the server. Please check your connection.");
    }
    setUploading(false);
  };
  return (
    <label data-testid={field.testid} className="flex cursor-pointer items-center gap-3 rounded-xl border-2 border-dashed border-sugar-border bg-sugar-bg px-4 py-3 text-sugar-ink2 hover:border-sugar-pink/60">
      {uploading ? <Loader2 size={18} className="animate-spin text-sugar-pink" /> : value ? <Check size={18} className="text-sugar-pink" /> : <ImagePlus size={18} className="text-sugar-pink" />}
      <span className="text-sm font-semibold">{uploading ? "Uploading…" : value ? `Added: ${name || "photo"}` : "Add a photo of a cake you love"}</span>
      <input type="file" accept="image/*" className="hidden" disabled={uploading} onChange={upload} />
    </label>
  );
};

export const FormFieldInput = ({ field, value, onChange }) => {
  if (field.type === "image") return <ImageField field={field} value={value} onChange={onChange} />;
  if (field.type === "textarea") return <Textarea data-testid={field.testid} value={value} placeholder={field.placeholder} onChange={(e) => onChange(e.target.value)} className="min-h-28 rounded-xl border-sugar-border" />;
  if (field.type === "select") return (
    <select data-testid={field.testid} value={value} onChange={(e) => onChange(e.target.value)} className={selectCls}>
      <option value="">Please select</option>
      {field.options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  );
  return <Input data-testid={field.testid} type={field.type} value={value} placeholder={field.placeholder} onChange={(e) => onChange(e.target.value)} className="rounded-xl border-sugar-border" />;
};
